import React, { useEffect } from 'react';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
// import Base, { Breadcrumbs } from '../../layout';

import { useForm, Controller } from 'react-hook-form';
import UserServices from '../services/user.services';
import OrganisationServices from '../services/organization.services';
import PhoneInput from 'react-phone-input-2';
// import TimezoneDropDown from './timezone.dropdown';

const required = 'This field is required';
const maxLength = 'Your input exceed maximum length';
const invalidPhone = 'Please enter valide Mobile Number';
const invalidEmail = 'Please enter valid Email';
const invalidPassword =
    'Password should be combination of one uppercase , one lower case, one special char, one digit and min 8 , max 20 characters long';
const hintPassword = 'Hint:Abc@1234';
const errorMessage = (error) => {
    return <div className="text-danger">{error}</div>;
};

// eslint-disable-next-line react/prop-types
const CreateUpdateUser = ({ isOrganizationUser }) => {
    const history = useHistory();
    let { id } = useParams();
    const [isEdit, setIsEdit] = useState(false);
    const [timezonesList, setTimezonesList] = useState([]);

    let defaultUserInfo = {
        firstName: '',
        lastName: '',
        emailId: '',
        jobTitle: '',
        countryCode: '91',
        mobileNumber: '',
        password: '',
        timezoneId: 0,
        subscriptionId: 0,
        profilePicture: null
    };

    const [subscriptionList, setSubscriptionList] = useState([]);
    const fetchTimezones = async () => {
        await UserServices.getAllTimezones()
            .then((res) => {
                console.log(res.data.data.timezone);
                setTimezonesList(res.data.data.timezone);
                console.log(timezonesList);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(async () => {
        await fetchTimezones();
        if (!isOrganizationUser) {
            await getSubscriptionList('user');
            if (id != 0) {
                setIsEdit(true);

                UserServices.getUser(id)
                    .then((res) => {
                        let data = { ...res.data.data, profilePicture: null };
                        reset(data);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                setIsEdit(false);
            }
        }
    }, []);

    const getSubscriptionList = async (type) => {
        await OrganisationServices.getSubscriptions(type)
            .then((res) => {
                setSubscriptionList(res.data.data);
                console.log('api response', res.data.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const isEmailExist = async (email) => {
        return await UserServices.checkEmail(email)
            .then((res) => {
                console.log(res.data);
                if (res.data.data.code === 'IN_USE') {
                    return true;
                } else {
                    return false;
                }
                //TODO:show error message for duplication email
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const saveUser = (data) => {
        if (isOrganizationUser) {
            OrganisationServices.createOrganizationUser(id, data)
                .then((res) => {
                    console.log(res);
                    history.push({ pathname: '/organization-accounts' });
                })
                .catch((err) => {
                    console.log(err);
                });
        } else if (isEdit) {
            delete data.password;
            UserServices.updateUser(id, data)
                .then((res) => {
                    console.log(res);
                    goToList();
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            UserServices.createUser(data)
                .then((res) => {
                    console.log(res);
                    goToList();
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    function goToList() {
        history.push({ pathname: '/user-accounts' });
    }

    const { register, handleSubmit, errors, reset, control, formState } = useForm({
        mode: 'onBlur',
        defaultValues: defaultUserInfo
    });
    const { isValid } = formState;

    const resetForm = () => {
        reset(defaultUserInfo);
    };

    function preventSpecialSymbols(e) {
        let k = e.keyCode;
        if (!(k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57)) {
            if (k != 9 && k != 8) {
                e.preventDefault();
            }
        }
    }

    return (
        <form
            id="form-validation"
            action="page_forms_validation.html"
            method="post"
            className="form-horizontal form-bordered"
            onSubmit={handleSubmit(saveUser)}>
            <div className="form-group">
                <label className="col-md-4 control-label" htmlFor="val-firstname">
                    First Name <span className="text-danger">*</span>
                </label>
                <div className="col-md-7">
                    <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        className="form-control"
                        placeholder="Enter your first name.."
                        maxLength="150"
                        onKeyDown={(e) => preventSpecialSymbols(e)}
                        ref={register({ required: true, maxLength: 150 })}
                    />
                    {errors.firstName && errors.firstName.type === 'required' && errorMessage(required)}
                    {errors.firstName && errors.firstName.type === 'maxLength' && errorMessage(maxLength)}
                </div>
            </div>
            <div className="form-group">
                <label className="col-md-4 control-label" htmlFor="val-lastname">
                    Last Name <span className="text-danger">*</span>
                </label>
                <div className="col-md-7">
                    <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        className="form-control"
                        maxLength="150"
                        placeholder="Enter your last name.."
                        onKeyDown={(e) => preventSpecialSymbols(e)}
                        ref={register({ required: true, maxLength: 150 })}
                    />
                    {errors.lastName && errors.lastName.type === 'required' && errorMessage(required)}
                    {errors.lastName && errors.lastName.type === 'maxLength' && errorMessage(maxLength)}
                </div>
            </div>
            <div className="form-group">
                <label className="col-md-4 control-label" htmlFor="val-jobtitle">
                    Job Title
                </label>
                <div className="col-md-7">
                    <input
                        type="text"
                        id="jobTitle"
                        name="jobTitle"
                        className="form-control"
                        placeholder="Enter job title.."
                        maxLength="150"
                        ref={register}
                    />
                </div>
            </div>
            {/* <div className="form-group">
                <label className="col-md-4 control-label" htmlFor="val-countrycode">
                    Country Code <span className="text-danger">*</span>
                </label>
                <div className="col-md-7">
                    <input
                        type="number"
                        id="countryCode"
                        name="countryCode"
                        className="form-control"
                        maxLength="5"
                        placeholder="Enter country code.."
                        ref={register({ required: true, maxLength: 5 })}
                    />
                    {errors.countryCode && errors.countryCode.type === 'required' && errorMessage(required)}
                    {errors.countryCode && errors.countryCode.type === 'maxLength' && errorMessage(maxLength)}
                </div>
            </div> */}
            {/* <TimezoneDropDown registers={register} error={errors.timezoneId} /> */}
            <div className="form-group">
                <label className="col-md-4 control-label" htmlFor="val-acctype">
                    Timezone <span className="text-danger">*</span>
                </label>
                <div className="col-md-7">
                    <select
                        id="timezoneId"
                        name="timezoneId"
                        className="form-control"
                        ref={register({ validate: (value) => value != 0 })}>
                        <option value={0}>Please select</option>
                        {timezonesList.length > 0 &&
                            timezonesList.map((timezone) => (
                                <option key={timezone.id} value={timezone.id}>
                                    {timezone.timeZoneName} ({timezone.offset})
                                </option>
                            ))}
                    </select>
                    {errors.timezoneId && errorMessage(required)}
                </div>
            </div>
            {/* <div className="form-group">
                <label className="col-md-4 control-label" htmlFor="val-mobilenumber">
                    Mobile Number <span className="text-danger">*</span>
                </label>
                <div className="col-md-7">
                    <input
                        type="text"
                        id="mobileNumber"
                        name="mobileNumber"
                        className="form-control"
                        maxLength="15"
                        onKeyDown={(e) => restrictAphaBetInPhoneNumber(e)}
                        placeholder="Enter Mobile Number.."
                        ref={register({ required: true, maxLength: 11, minLength: 8 })}
                    />
                    {errors.mobileNumber && errors.mobileNumber.type === 'required' && errorMessage(required)}
                    {errors.mobileNumber &&
                        (errors.mobileNumber.type === 'maxLength' || errors.mobileNumber.type === 'minLength') &&
                        errorMessage(invalidPhone)}
                </div>
            </div> */}
            <div className="form-group">
                <label className="col-md-4 control-label" htmlFor="val-mobilenumber">
                    Mobile Number <span className="text-danger">*</span>
                </label>
                <div className="col-md-7">
                    <Controller
                        as={
                            <PhoneInput
                                country={'us'}
                                autoFormat
                                countryCodeEditable={false}
                                enableSearch
                                containerClass="w-full"
                                buttonClass="rounded "
                            />
                        }
                        name="mobileNumber"
                        control={control}
                        rules={{ required: true, minLength: 10 }}
                        defaultValue=""
                    />

                    {errors.mobileNumber && errors.mobileNumber.type === 'required' && errorMessage(required)}
                    {errors.mobileNumber &&
                        (errors.mobileNumber.type === 'maxLength' || errors.mobileNumber.type === 'minLength') &&
                        errorMessage(invalidPhone)}
                </div>
            </div>
            {!isOrganizationUser && (
                <div className="form-group">
                    <label className="col-md-4 control-label" htmlFor="val-acctype">
                        Subscription Type <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-7">
                        <select
                            id="subscriptionId"
                            name="subscriptionId"
                            className="form-control"
                            ref={register({ validate: (value) => value != 0 })}>
                            <option value={0}>Please select</option>
                            {subscriptionList.length > 0 &&
                                subscriptionList.map((subs) => (
                                    <option key={subs.id} value={subs.id}>
                                        {subs.name}
                                    </option>
                                ))}
                        </select>
                        {errors.subscriptionId && errorMessage(required)}
                    </div>
                </div>
            )}

            <div className="form-group">
                <label className="col-md-4 control-label" htmlFor="val-emailid">
                    Email Address <span className="text-danger">*</span>
                </label>
                <div className="col-md-7">
                    <input
                        type="text"
                        id="emailId"
                        name="emailId"
                        className="form-control"
                        disabled={isEdit}
                        placeholder="Enter Email Address.."
                        ref={register({
                            required: true,
                            pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                            validate: (value) => {
                                if (!isEdit) {
                                    return isEmailExist(value).then((res) => {
                                        return !res;
                                    });
                                }
                            }
                        })}
                    />
                    {errors.emailId && errors.emailId.type === 'required' && errorMessage(required)}
                    {errors.emailId && errors.emailId.type === 'pattern' && errorMessage(invalidEmail)}
                    {errors
                        ? errors.emailId && errors.emailId.type === 'validate' && errorMessage('Email adready exist')
                        : ''}
                </div>
            </div>

            {!isEdit && (
                <div className="form-group">
                    <label className="col-md-4 control-label" htmlFor="val-password">
                        Password <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-7">
                        <input
                            type="password"
                            id="password"
                            name="password"
                            className="form-control"
                            placeholder="Password"
                            maxLength="20"
                            minLength="8"
                            ref={register({
                                required: true,
                                pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/
                            })}
                        />
                        {errors.password && errors.password.type === 'required' && errorMessage(required)}
                        {errors.password && errors.password.type === 'pattern' && errorMessage(invalidPassword)}
                        {errors.password && errors.password.type === 'pattern' && errorMessage(hintPassword)}
                    </div>
                </div>
            )}
            <div className="form-group">
                <label className="col-md-4 control-label" htmlFor="profilePicture">
                    Profile Picture
                </label>
                <div className="col-md-7">
                    <input type="file" id="val-profilepic" name="profilePicture" ref={register} />
                </div>
            </div>
            <div className="form-group form-actions">
                <div className="col-md-7 col-md-offset-4">
                    <button type="submit" disabled={!isValid} className="btn btn-effect-ripple btn-primary">
                        Submit
                    </button>
                    {!isEdit || isOrganizationUser ? (
                        <button type="reset" onClick={resetForm} className="btn btn-effect-ripple btn-danger">
                            Reset
                        </button>
                    ) : (
                        <button onClick={goToList} className="btn btn-effect-ripple btn-danger">
                            Back
                        </button>
                    )}
                </div>
            </div>
        </form>
    );
};

export default CreateUpdateUser;
